
<div>
  <div class="container-fluid fixed-top">
    <app-header></app-header>
  </div>

  <div class="container-fluid py-5 mt-5 margin-top-5" id="top-page">
    <div class="container py-5 mt-5">
      <div class="row g-4 mb-5">
        <div class="col-lg-8 col-xl-9">
          <div class="row g-4">
            <app-product-info [product]="productInfo"></app-product-info>
          </div>
        </div>
        <div class="col-lg-4 col-xl-3">
          <div class="row g-4 fruite">
            <app-offers-info [numSlides]="1"  [title]="'Nuestras Ofertas'"></app-offers-info>
          </div>
        </div>
        <div class="col-12">
          <app-related-product  [title]="'Otros Productos'" [numSlides]="4" ></app-related-product>
        </div>
      </div>
    </div>
  </div>


  <div>
    <app-footer></app-footer>
  </div>
</div>
